"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getSize = require("get-size");

var _getSize2 = _interopRequireDefault(_getSize);

var _elementResizeDetector = require("element-resize-detector");

var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);

var _postRobot = require("post-robot");

var postRobot = _interopRequireWildcard(_postRobot);

var _WidgetFactories = require("./WidgetFactories");

var _WidgetFactories2 = _interopRequireDefault(_WidgetFactories);

var _events = require("./events");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 *
 * @param eventName
 * @param listener
 * @param windowObject
 */
var addWindowEventListener = function addWindowEventListener(eventName, listener, windowObject) {
  var addListener = windowObject.addEventListener ? windowObject.addEventListener : windowObject.attachEvent;
  var event = windowObject.addEventListener ? eventName : 'on' + eventName;

  addListener(event, listener);
};

/**
 * @ignore
 *
 * @param windowBridge
 * @param e
 */
var mouseEventHandler = function mouseEventHandler(windowBridge, e) {
  var scalarKeys = function scalarKeys(original) {
    var obj = {};
    for (var key in original) {
      obj[key] = (0, _typeof3.default)(original[key]) === 'object' ? {} : original[key];
    }
    return obj;
  };

  var payload = JSON.parse((0, _stringify2.default)(scalarKeys(e)));
  windowBridge.emitRequest(_events.EVENT_WINDOW_MOUSEEVENT, payload).then(function (_ref) {
    var emit = _ref.emit;
    return emit();
  });
};

var isResizing = false;
/**
 * @ignore
 *
 * @param {WidgetWindowBridge} windowBridge
 * @return {null}
 */
var windowSizeChangeHandler = function windowSizeChangeHandler(windowBridge) {
  if (isResizing) {
    return null;
  }

  isResizing = true;
  windowBridge.emitRequest(_events.EVENT_WINDOW_RESIZE, { size: windowBridge.bodySize }).then(function (_ref2) {
    var emit = _ref2.emit;
    return emit();
  }).then(function () {
    isResizing = false;
  });
};

var mouseEvents = ['mousedown', 'mouseup'];

/**
 * A representation of a widget/application `Window`, conceptually similar to the browser window object
 *
 * It is also communication bridge between the widget/application Window object and the helpdesk Window. In most of the cases the helpdesk Window
 * is hosting the widget window in an iframe
 *
 * @class
 */

var WidgetWindowBridge = function () {

  /**
   * @param {Window} windowObject
   * @param {InitPropertiesBag} initProps
   */
  function WidgetWindowBridge(windowObject, initProps) {
    (0, _classCallCheck3.default)(this, WidgetWindowBridge);

    this.props = { windowObject: windowObject, initProps: initProps };

    var onLoadExecutor = function onLoadExecutor(resolve, reject) {
      if (windowObject.document.readyState === 'complete') {
        resolve();
      }
      addWindowEventListener('load', resolve, windowObject);
    };
    this.onLoadPromise = new _promise2.default(onLoadExecutor);
  }

  /**
   * The id of the widget
   *
   * @type {String}
   */


  (0, _createClass3.default)(WidgetWindowBridge, [{
    key: "connect",


    /**
     * Connects the widget/application window and the helpdesk window. The `createApp` function will be invoked on a successful connection
     *
     * @param {function} createApp an application factory
     * @return {Promise.<AppClient, Error>}
     */
    value: function connect(createApp) {
      var _this = this;

      var windowObject = this.props.windowObject;
      var widgetId = this.widgetId;


      return this.onLoadPromise.then(function () {
        return postRobot.send(postRobot.parent, "urn:deskpro:apps.widget.onready?widgetId=" + widgetId, {}).then(function (event) {
          return event.data;
        });
      }).then(function (o) {
        return createApp((0, _extends3.default)({}, o, { widgetWindow: _this }));
      }).then(function (app) {

        // reduce verbosity of post-robot logging
        if (app.environment === 'production') {
          postRobot.CONFIG.LOG_LEVEL = 'error';
        }

        var handler = mouseEventHandler.bind(null, _this);
        mouseEvents.forEach(function (event) {
          return addWindowEventListener(event, handler, windowObject);
        });

        // register the window resize strategy
        _this.erd = (0, _elementResizeDetector2.default)({ strategy: "scroll" });
        _this.erd.listenTo(windowObject.document.body, windowSizeChangeHandler.bind(null, _this));

        return app;
      });
    }

    /**
     * Dispatches an event to the helpdesk `Window`
     *
     * @param {String} eventName
     * @param {function} handler
     */

  }, {
    key: "on",
    value: function on(eventName, handler) {
      postRobot.on(eventName, handler);
    }

    /**
     * Sends a response message back to the helpdesk `Window`
     *
     * @param {String} eventName
     * @param {Error|null} error
     * @param {{}} data
     * @param {WidgetRequest} request
     * @return {Promise.<{response: WidgetResponse, emit: (function())}>}
     */

  }, {
    key: "emitResponse",
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(eventName, error, data, request) {
        var widgetId, response, payload, event, emit;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                widgetId = this.widgetId;
                response = _WidgetFactories2.default.nextResponse(request, error ? error : data, !!error);
                payload = (0, _extends3.default)({ eventName: eventName }, response.toJS());
                event = "urn:deskpro:apps.widget.event?widgetId=" + widgetId;

                emit = function emit() {
                  postRobot.send(postRobot.parent, event, payload);
                };

                return _context.abrupt("return", _promise2.default.resolve({ response: response, emit: emit }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function emitResponse(_x, _x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return emitResponse;
    }()

    /**
     * Sends a request message back to the helpdesk `Window`
     *
     * @param {String} eventName
     * @param {*} data
     * @return {Promise.<{request: WidgetRequest, emit: (function())}>}
     */

  }, {
    key: "emitRequest",
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(eventName, data) {
        var widgetId, request, payload, event, emit;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                widgetId = this.widgetId;
                request = _WidgetFactories2.default.nextRequest(widgetId, data);
                payload = (0, _extends3.default)({ eventName: eventName }, request.toJS());
                event = "urn:deskpro:apps.widget.event?widgetId=" + widgetId;

                emit = function emit() {
                  postRobot.send(postRobot.parent, event, payload);
                };

                return _context2.abrupt("return", _promise2.default.resolve({ request: request, emit: emit }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function emitRequest(_x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return emitRequest;
    }()

    /**
     * The size of the widget window
     *
     * @public
     * @constant
     *
     * @type {WidgetWindowSize}
     */

  }, {
    key: "widgetId",
    get: function get() {
      var initProps = this.props.initProps;

      return initProps.dpWidgetId;
    }
  }, {
    key: "bodySize",
    get: function get() {
      var windowObject = this.props.windowObject;

      return (0, _getSize2.default)(windowObject.document.body);
    }
  }]);
  return WidgetWindowBridge;
}();

exports.default = WidgetWindowBridge;

/**
 * GetSize Type.
 *
 * @typedef {Object} WidgetWindowSize
 * @property {number} width - Size in pixels.
 * @property {number} height - Size in pixels.
 * @property {number} innerWidth - Size in pixels.
 * @property {number} innerHeight - Size in pixels.
 * @property {number} outerWidth - Size in pixels.
 * @property {number} outerHeight - Size in pixels.
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/WidgetWindowBridge.js
// module id = 135
// module chunks = 0